function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.312 16.067s1.703 4.891 1.034 7.233C1.278 30.534.245 32.6 2.311 45H50.88c1.54 0 4.472-4.111 3.125-4.857-8.49-4.697-21.37-6.57-27.882-16.112-2.145-3.142-5.209-10.03-5.209-10.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.312 45s-.93 6.2 1.137 6.2h47.43c1.461 0 2.54-1.75 3.1-3.1 1.054-2.546.517-7.233.517-7.233"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.725,
  cy: 31.387,
  r: 4.313,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.812 22.267l6.2-2.067M20.912 28.467l5.167-4.133M25.046 33.633l5.167-5.167M31.246 37.767l3.1-6.2M39.512 45c1.033-2.531 2.067-5.787 8.267-7.853"
}));

var SvgShoe = function SvgShoe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Shoe.6ed514db.svg";
export { ForwardRef as ReactComponent };